import React from 'react';
import { colors } from '../../config/colors';
import { parseTeethList } from '../../utils/teethList';

const TeethSelector = ({ selectedTeeth, onTeethSelect }) => {
  const teethGroups = [
    ['18', '17', '16', '15', '14', '13', '12', '11'],
    ['21', '22', '23', '24', '25', '26', '27', '28'],
    ['55', '54', '53', '52', '51'],
    ['61', '62', '63', '64', '65'],
    ['48', '47', '46', '45', '44', '43', '42', '41'],
    ['31', '32', '33', '34', '35', '36', '37', '38'],
    ['85', '84', '83', '82', '81'],
    ['71', '72', '73', '74', '75']
  ];

  const handleTeethClick = (toothNumber) => {
    const currentSelected = parseTeethList(selectedTeeth);
    const newSelected = currentSelected.includes(toothNumber)
      ? currentSelected.filter(num => num !== toothNumber)
      : [...currentSelected, toothNumber];
    
    onTeethSelect(newSelected.sort((a, b) => Number(a) - Number(b)).join(','));
  };

  const isSelected = (toothNumber) => {
    return parseTeethList(selectedTeeth).includes(toothNumber);
  };

  const shouldHaveThickBorder = (tooth) => {
    return ['11', '41', '51', '81'].includes(tooth);
  };

  const renderToothButton = (tooth) => (
    <button
      key={tooth}
      type="button"
      onClick={() => handleTeethClick(tooth)}
      className={`
        min-w-[2rem] p-1 text-sm border-0 border-r-0
        ${shouldHaveThickBorder(tooth) ? 'border-r-2' : ''}
        ${isSelected(tooth)
          ? 'bg-[rgb(141,212,209)] text-gray-700 border-gray-300'
          : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'}
        transition-colors duration-150
        focus:outline-none
      `}
    >
      {tooth}
    </button>
  );

  const renderTeethRow = (firstGroup, secondGroup, childGroup1, childGroup2) => (
    <div className="flex items-center">
      {/* Adult teeth groups */}
      <div className="flex border border-gray-300">
        {firstGroup.map(tooth => renderToothButton(tooth))}
        {secondGroup.map(tooth => renderToothButton(tooth))}
      </div>
      
      {/* Child teeth groups */}
      <div className="ml-4 flex border border-gray-300">
        {childGroup1.map(tooth => renderToothButton(tooth))}
        {childGroup2.map(tooth => renderToothButton(tooth))}
      </div>
    </div>
  );

  return (
    <div>
      {/* Top Row */}
      {renderTeethRow(
        teethGroups[0], // 18-11
        teethGroups[1], // 21-28
        teethGroups[2], // 55-51
        teethGroups[3]  // 61-65
      )}

      {/* Bottom Row */}
      {renderTeethRow(
        teethGroups[4], // 48-41
        teethGroups[5], // 31-38
        teethGroups[6], // 85-81
        teethGroups[7]  // 71-75
      )}
    </div>
  );
};

export default TeethSelector; 